/**
 * 配車計画 最終更新
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/allocations/last_updates`

const allocation_last_update = {
  namespaced: true,
  actions: {
    show ({ commit }, { target_date }) {
      const params = { target_date: target_date }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
}

export default allocation_last_update
